import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

// Datos de los testimonios
const testimonials = [
  {
    id: 1,
    name: 'Carlos Martínez',
    role: 'Empresario',
    quote: 'El servicio personalizado de LuxuryEstates superó todas mis expectativas. Encontraron exactamente lo que buscaba en tiempo récord.',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80',
    rating: 5
  },
  {
    id: 2,
    name: 'Elena Gómez',
    role: 'Directora de Marketing',
    quote: 'La atención al detalle y el conocimiento del mercado inmobiliario de lujo me impresionaron. Sin duda, la mejor decisión para encontrar mi hogar.',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80',
    rating: 5
  },
  {
    id: 3,
    name: 'Javier Ruiz',
    role: 'Arquitecto',
    quote: 'Como profesional del sector, valoro enormemente la calidad de las propiedades que ofrecen. El proceso de compra fue impecable de principio a fin.',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80',
    rating: 4
  }
];

// Componente para mostrar las estrellas de valoración
const RatingStars: React.FC<{ rating: number }> = ({ rating }) => {
  return (
    <div className="flex">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          size={16}
          className={`${
            i < rating ? 'text-secondary fill-secondary' : 'text-gray-300'
          }`}
        />
      ))}
    </div>
  );
};

// Componente para cada tarjeta de testimonio
const TestimonialCard: React.FC<{
  testimonial: typeof testimonials[0];
  index: number;
}> = ({ testimonial, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.2 }}
      className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md"
    >
      <div className="flex items-center mb-4">
        <img
          src={testimonial.avatar}
          alt={testimonial.name}
          className="w-12 h-12 rounded-full object-cover mr-4"
        />
        <div>
          <h4 className="font-medium text-dark dark:text-light">{testimonial.name}</h4>
          <p className="text-sm text-gray-500 dark:text-gray-400">{testimonial.role}</p>
        </div>
      </div>
      <RatingStars rating={testimonial.rating} />
      <blockquote className="mt-4 text-gray-600 dark:text-gray-300 italic">
        "{testimonial.quote}"
      </blockquote>
    </motion.div>
  );
};

const Testimonials: React.FC = () => {
  return (
    <section id="testimonials" className="section bg-light dark:bg-dark">
      <div className="container">
        <div className="text-center mb-12">
          <motion.h2
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-3xl md:text-4xl font-serif font-bold text-dark dark:text-light mb-4"
          >
            Lo Que Dicen Nuestros Clientes
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="w-24 h-1 bg-secondary mx-auto mb-6"
          ></motion.div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto"
          >
            La satisfacción de nuestros clientes es nuestro mayor logro. Estas son algunas de sus experiencias.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={testimonial.id} testimonial={testimonial} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;